import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BASEAPIURL, BASEURL, UPLOADNODEURL } from '../../../../config';

function MyPurchasePage() {
    const [isLoded, SetisLoded] = useState(false);
    const [ShowType, SetShowType] = useState('MainCourse');
    const [FavCourse, SetFavCourse] = useState([]);
    const GerFavorites = async (targetType) => {
        try {
            const res = await fetch(`${BASEAPIURL}/student/PurchasedCourseList`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                },
                body: JSON.stringify({
                    targetType,
                    usertype: localStorage.getItem('usertype'),
                }),
            });
            const resJson = await res.json();
            SetisLoded(true);
            if (resJson.data) {
                switch (targetType) {
                    case 'MainCourse':
                        SetFavCourse(resJson.data);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        GerFavorites('MainCourse');
    }, []);
    return (
        <>
            {/* {ShowType} */}
            <div className="ry_instr_shadow p-4" style={{ display: isLoded ? '' : 'none' }}>
                <h4 className="std_header_on_page">My Purchase</h4>
                <div className="row">
                    <div className="col-md-12">
                        <div
                            className="col-md-12 mt-4"
                            style={{
                                backgroundColor: 'lightgrey',
                                borderRadius: '10px',
                            }}
                        >
                            <ul className="nav" style={{ text: 'black' }}>
                                {/* <li className="col-md-1"></li> */}
                                <li className="nav-item col-md-2 p-1 text-center">
                                    <a
                                        className={ShowType === 'courses' ? 'selectedTabProfile' : ''}
                                        href="/"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            SetShowType('courses');
                                        }}
                                    >
                                        Courses
                                    </a>
                                </li>

                                <li className="nav-item col-md-2 p-1 text-center">
                                    <a
                                        className={ShowType === 'eproducts' ? 'selectedTabProfile' : ''}
                                        href="/"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            SetShowType('eproducts');
                                        }}

                                    >
                                        E-products
                                    </a>
                                </li>
                            </ul>
                        </div>


                        
                        {/* For Favarate product */}
                        <div style={{ display: ShowType === 'eproducts' ? '' : 'none' }}>
                            <div
                                className="col-md-12 std_header_on_page"
                                style={{
                                    backgroundColor: '#f0eeee',
                                    borderRadius: '5px',
                                    padding: '20px',
                                    paddingTop: '40px',
                                    paddingBottom: '40px',
                                    textAlign: 'center',
                                    display: FavCourse && FavCourse.filter((s) => s.section === 'eproducts').length === 0 ? '' : 'none',
                                }}
                            >
                                <p>No E-products bought yet.</p>
                                <br />
                                <div className="header-nav-box">
                                    <div className="appie-btn-box">
                                        <Link
                                            to="/courses/eproducts"
                                            target="_BLANK"
                                            className="signup-btn "
                                            style={{ margin: '0px auto' }}
                                        >
                                            Browse E-products now
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3">
                                <div className="row">
                                    {FavCourse
                                        .filter((s) => s.section === 'eproducts')
                                        .map((s) => (
                                        <div className="col-md-4" key={s.image}>
                                            <div
                                                className="text-center"
                                                style={{
                                                    border: '1px solid #f5f5f5',
                                                    background: '#fff',
                                                    marginBottom: '10px',
                                                    paddingBottom: '10px',
                                                }}
                                            >
                                                <a
                                                    href={`${BASEURL}courseStudent/${s.slug}`}
                                                    target="_MainCourse"
                                                    rel="noreferrer"
                                                >
                                                    <img
                                                        src={`${UPLOADNODEURL}${s.image}`}
                                                        alt=""
                                                        style={{
                                                            objectFit: 'cover',
                                                            height: '180px',
                                                            width: '100%',
                                                        }}
                                                    />
                                                    <b title={s.title} className="CLB_course_title">
                                                        {s.title}
                                                    </b>
                                                </a>
                                                <a
                                                    href={`${BASEURL}courseStudent/${s.slug}`}
                                                    target="_MainCourse"
                                                    rel="noreferrer"
                                                    className="btn text-left p-0 pl-2 pr-2 buynow-btn"
                                                    style={{ borderRadius: '0px' }}
                                                >
                                                    Resume Course
                                                </a>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {/* For Favarate product */}

                        {/* For Favarate course */}
                        <div style={{ display: (ShowType === 'courses' || ShowType === 'MainCourse') ? '' : 'none' }}>
                            <div
                                className="col-md-12 std_header_on_page"
                                style={{
                                    backgroundColor: '#f0eeee',
                                    borderRadius: '5px',
                                    padding: '20px',
                                    paddingTop: '40px',
                                    paddingBottom: '40px',
                                    textAlign: 'center',
                                    display: FavCourse && FavCourse.filter((s) => s.section === 'courses').length === 0 ? '' : 'none',
                                }}
                            >
                                <p>No Courses bought yet.</p>
                                <br />
                                <div className="header-nav-box">
                                    <div className="appie-btn-box">
                                        <Link
                                            to="/courses"
                                            target="_BLANK"
                                            className="signup-btn "
                                            style={{ margin: '0px auto' }}
                                        >
                                            Browse Courses now
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-3">
                                <div className="row">
                                    {FavCourse
                                        .filter((s) => s.section === 'courses')
                                        .map((s) => (
                                        <div className="col-md-4" key={s.image}>
                                            <div
                                                className="text-center"
                                                style={{
                                                    border: '1px solid #f5f5f5',
                                                    background: '#fff',
                                                    marginBottom: '10px',
                                                    paddingBottom: '10px',
                                                }}
                                            >
                                                <a
                                                    href={`${BASEURL}courseStudent/${s.slug}`}
                                                    target="_MainCourse"
                                                    rel="noreferrer"
                                                >
                                                    <img
                                                        src={`${UPLOADNODEURL}${s.image}`}
                                                        alt=""
                                                        style={{
                                                            objectFit: 'cover',
                                                            height: '180px',
                                                            width: '100%',
                                                        }}
                                                    />
                                                    <b title={s.title} className="CLB_course_title">
                                                        {s.title}
                                                    </b>
                                                </a>
                                                <a
                                                    href={`${BASEURL}courseStudent/${s.slug}`}
                                                    target="_MainCourse"
                                                    rel="noreferrer"
                                                    className="btn text-left p-0 pl-2 pr-2 buynow-btn"
                                                    style={{ borderRadius: '0px' }}
                                                >
                                                    Resume Course
                                                </a>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/* For Favarate course */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MyPurchasePage;
